import { LinearProgress } from '@mui/joy';
import { Stack, Typography } from '@mui/joy';

export function LinearProgressBar({ value, max, sx }) {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1.25} sx={sx}>
      <LinearProgress determinate value={value / max * 100} thickness={5} />
      <Typography level="title-sm" sx={{ color: 'var(--joy-palette-neutral-700)' }}>{value}/{max}</Typography>
    </Stack>
  );
}
